<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">订单评价</h1>
            <div class="od_stus" style="background-color:#f00180">
                <p class="od_tt">
                    <img src="https://s.cccgx.com/mobile/asset/css/u/u_ods3.png" class="od_img">{{orderInfo.status}}
                </p>
                <p class="od_sub">订单{{orderInfo.status}}</p>
            </div>
            <div class="ysd_box">
                <div class="u_ifo">
                    <img src="https://s.cccgx.com//themes/v4/css/u/u_od_dz.png" class="u_if_img">
                    <p class="u_if_name">{{orderInfo.mail_name}} {{orderInfo.mail_tel}}</p>
                    <p class="u_ifdress">{{orderInfo.mail_province}}{{orderInfo.mail_city}}{{orderInfo.mail_area}}{{orderInfo.mail_town}}{{orderInfo.mail_address}}</p>
                </div>
            </div>
            <!--one over-->
            <!--商品begin-->
            <div class="goods_bx">
                <div class="goods_pone goods_offs">
                    <router-link :to="{path:'/detail', query:{id:orderInfo.pid}}" target="_blank" class="by_a_r">
                        <div style="height:80px; overflow:hidden;width:100%;">
                            <img :src="orderInfo.piclink" width="45" height="45" class="by_pic">
                            <p class="by_tt">{{orderInfo.title}}</p>
                            <p class="by_atr">{{orderInfo.sku_cn}}</p>
                            <em class="by_price">¥{{$fnc.toFixedZ(orderInfo.money)}}</em>
                            <em class="by_num">X{{orderInfo.number}}</em>
                        </div>
                    </router-link>
                    <div class="over">
                        <a class="db_btn" href="javascript:;" @click="$router.push({path: '/detail', query:{id:orderInfo.cid}})" v-if="orderInfo.status=='已完成'">再次购买</a>
                    </div>
                    <!--商品over-->
                    <div class="order_msg">
                        <h2 class="od_msgt">产品评价</h2>
                        <div class="od_msg">
                            <div class="od_ob">
                                <h3 style="font-size:14px;">内容评价：</h3>
                                <textarea maxlength="800" v-model="sub_review.content" name="" placeholder="请输入您的评价" class="ap_t" id="c_des"></textarea>
                            </div>
                            <div class="od_ob">
                                <input type="submit"  @click="sub_btn" class="b_sub" :value="$h('提交评价')">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wai" id="amlit">
                    <p class="over">
                        <em class="left">商品总价</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">优惠折扣</em>
                        <em class="right">¥{{$fnc.toFixedZ(orderInfo.red_money)}}</em>
                    </p>
                    <p class="over">
                        <em class="left">运费</em><em class="right">免邮</em>
                    </p>
                    <p class="btf"></p>
                    <div class="over">
                        <span class="left">{{pro_length}}件商品</span>
                        <p class="right">
                            总计<b class="red">¥</b>
                            <b class="red f16">{{$fnc.toFixedZ(orderInfo.money)}}</b>
                        </p>
                    </div>
                    
                    <!--wai over-->
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            message:"",
            orderInfo:{},
            pro_length:"",
            // mailInfo:"",
            mailInfo: {
                mail: {
                    Traces: []
                }
            },
            sub_review:{
                content:"",
            },
            info:{},
            inId:"",
            id:{},
        }
    },
    created(){
        this.getOrderDetails();
        this.getMail();
        this.getInfo();
    },
    mounted(){
        
    },
    methods:{
        getOrderDetail(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.oid = this.$route.query.oid || "";
            params.uid = this.$route.query.uid || "";
            this.$api.getOrder.getOrderDetail(params).then(res => {
                if(res.code == 200){
                    this.orderInfo = res.result;
                    this.pro_length = this.orderInfo.product.length;
                    var arr = res.result.product;
                    // console.log(this.orderInfo)
                    arr.forEach((item,index)=>{
                        this.$api.getOrder.getInfo(params).then(ress => {
                            if (ress.code == 200) {
                                this.info = ress.result;
                                // this.orderInfo = ress.result;
                                // this.pro_length = this.orderInfo.product.length;
                                // console.log(ress)
                                if (ress.result.is_review == 1) {
                                    this.sub_review.content = ress.result.review.content;
                                    this.sub_review = ress.result.review;
                                    // this.pic=res.result.review.piclink;
                                    ress.result.review.is_pic == 1 ? this.pic = ress.result.review.piclink : this.pic = [];
                                }
                            }
                        });
                    })
                }
            })
        },
        getOrderDetails(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.oid = this.$route.query.oid || "";
            params.uid = this.$route.query.uid || "";
            this.$api.getOrder.getInfo(params).then(ress => {
                if (ress.code == 200) {
                    this.orderInfo = ress.result;
                    if (ress.result.is_review == 1) {
                        this.sub_review.content = ress.result.review.content;
                        this.sub_review = ress.result.review;
                        ress.result.review.is_pic == 1 ? this.pic = ress.result.review.piclink : this.pic = [];
                    }
                }
            });
        },
        getMail(){
            var params = {}
            params.id = this.$route.query.id || "";
            params.oid = this.$route.query.oid || "";
            params.uid = this.$route.query.uid || "";
            this.$api.getOrder.getMail(params).then(res => {
                if(res.code == 200){
                    this.mailInfo = res.result;
                }
            })
        },
        sub_btn(){
            var params = {
                content: this.sub_review.content,
                id: this.$route.query.id || "",
                oid: this.$route.query.oid || "",
                uid: JSON.parse(window.localStorage.getItem("user")).id,
                star:5,
                latitude:0,
                longitude:0,
                address:"",
                private:"",
                video:"",
                video_id:"",
                video_piclink:"",
                
            };
            this.$api.getOrder.getPinjia(params).then((res) => {
                if (res.code == 200) {
                    this.$alert('已提交', '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                        window.location.reload();
                    });
                } else {
                    this.$alert(`${res.result}`, '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                        window.location.reload();
                    });
                }
            });
        },
        getInfo () {
            var params = {}
            params.id = this.$route.query.id || "";
            params.uid = this.$route.query.uid || "";
            this.$api.getOrder.getOrderDetail(params).then(res => {
                if(res.code == 200){
                    this.orderInfo = res.result;
                    var arr = res.result.product;
                    arr.forEach((item,index)=>{
                        this.$api.getOrder.getInfo({id:item.id,uid:item.uid}).then(ress => {
                            if (ress.code == 200) {
                                this.info = ress.result;
                                if (ress.result.is_review == 1) {
                                    this.sub_review.content = ress.result.review.content;
                                    this.sub_review = ress.result.review;
                                    ress.result.review.is_pic == 1 ? this.pic = ress.result.review.piclink : this.pic = [];
                                }
                            }
                        });
                    })
                    
                }
            })
            
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.ap_t{
    border: 1px solid #efefef;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
    /* line-height: 2rem; */
    background-color: #fff;
    width: 100%;
    height: 100px;
}
.by_a_r{
    display: block;
    position: relative;
    overflow: hidden;
    margin: 0 15px;
    padding: 0 75px 0 75px;
    /* height: 60px; */
    z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/order/order_review.vue